export const Status = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELED: 'canceled'
} as const

export interface Document {
  id: number
  category: DocumentCategoryType
  filename: string
}

export interface DocumentRequirement {
  name?: string
  displayName?: string
  document?: Document
}

export type DocumentStatus = typeof Status[keyof typeof Status]

export const CategoryType = {
  BALANCE_SHEET: 'balanceSheet',
  PROFIT_AND_LOSS_CURRENT: 'pLCurrentYear',
  PROFIT_AND_LOSS_PREVIOUS: 'pLPreviousYear',
  BUSINESS_BANK_STATEMENT: 'bankStatement',
  PERSONAL_BANK_STATEMENT: 'personalBankStatement',
  BUSINESS_TAX_RETURN: 'businessTaxReturns',
  BUSINESS_TAX_RETURN_EXTENSION: 'businessTaxReturnExtension',
  PERSONAL_TAX_RETURN: 'personalTaxReturns',
  PERSONAL_TAX_RETURN_EXTENSION: 'personalTaxReturnExtension',
  DRIVERS_LICENSE_FRONT: 'driversLicenseFront',
  DRIVERS_LICENSE_BACK: 'driversLicenseBack',
} as const

export type DocumentCategoryType = typeof CategoryType[keyof typeof CategoryType]

export const VerificationType = {
  IDENTIFICATION: 'identification',
  BELONGING: 'belonging',
  INTEGRITY: 'integrity',
} as const

export type DocumentVerificationType = typeof VerificationType[keyof typeof VerificationType]

export interface FailureDetails {
  verificationType: DocumentVerificationType | null
  message: string | null
  evaluatedType: DocumentCategoryType | null
}

export interface DocumentVerification {
  documentId: number
  categoryType: DocumentCategoryType
  status: DocumentStatus
  passed: boolean | null
  failureDetails?: FailureDetails | null
}

export interface DocumentVerificationEvent {
  documentId: number
  categoryType: DocumentCategoryType
  status: DocumentStatus
  passed: boolean | null
  verificationType: DocumentVerificationType | null
  message: string | null
  evaluatedType: DocumentCategoryType | null
}

export interface DocumentVerificationsResponse {
  data: DocumentVerification[]
}

export interface DocumentIntelligenceConfig {
  verificationsEnabled: boolean
}

export interface DocumentIntelligenceConfigResponse {
  data: DocumentIntelligenceConfig
}

export const LogLevel = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
} as const

export type LogLevelType = typeof LogLevel[keyof typeof LogLevel]

export const VerificationEvent = {
  MODAL_SHOWN: 'Document Verification Warning Modal Shown',
  MODAL_CONTINUE: 'Document Verification Warning Modal Continue',
  MODAL_CLOSE: 'Document Verification Warning Modal Close',
  VERIFICATION_UPLOAD: 'Document Verification Upload',
  VERIFICATION_WARNING: 'Document Verification Warning',
} as const

export type VerificationEventType = typeof VerificationEvent[keyof typeof VerificationEvent]
